import { render, staticRenderFns } from "./BranchCheckRecordList.vue?vue&type=template&id=3c072af0&"
import script from "./BranchCheckRecordList.vue?vue&type=script&lang=ts&"
export * from "./BranchCheckRecordList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports